import React from "react";
import { Link } from "react-router-dom";
import "./CourseCard.css";

const CourseCard = ({ course }) => {
  const getColorClass = (color) => {
    switch (color) {
      case "turquoise":
        return "card-turquoise";
      case "pink":
        return "card-pink";
      case "green":
        return "card-green";
      case "blue":
        return "card-blue";
      default:
        return "card-turquoise";
    }
  };

  return (
    <div className={`course-card ${getColorClass(course.color)}`}>
      <div className="card-header">
        <h3 className="card-title">{course.title}</h3>
        {/* {course.discount && (
          <div className="discount-badge">{course.discount}</div>
        )} */}
      </div>
      <div className="card-body">
        <p className="card-description">{course.description}</p>
        <div className="card-duration">
          <span className="duration-label">Duration:</span>
          <span className="duration-value">{course.duration}</span>
        </div>
      </div>
      <div className="card-footer">
        <Link
          to={`/enroll?course=${encodeURIComponent(course.title)}`}
          className="btn-enroll"
        >
          Enroll Now
        </Link>
      </div>
    </div>
  );
};

export default CourseCard;
